import { Apollo, gql } from 'apollo-angular';
import { Component, Inject, OnInit } from '@angular/core';

import { RouterOutlet, Router, ActivatedRoute } from '@angular/router';
import { PortalService } from './services/portal.service';
import { AuthGuardService } from './services/auth.guard.service';
import { SharedDataService } from './services/shared-data.service';
import { JwtDecoderService } from './services/jwt-decoder.service';
import { HttpHeaders } from '@angular/common/http'
import { MerchantService } from './services/merchant.service'
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        RouterOutlet
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'portal-comercio-test';
  queryParamCode: string;

  constructor(
    ) { 
    this.queryParamCode = '';
  }

  public ngOnInit() {
  }
}
